import { styled } from "@mui/material/styles";
import { Dialog } from "@mui/material";

const PREFIX = "APICredentialsComponent";
export const classes = {
  dialogTitleWrap: `${PREFIX}-dialogTitleWrap`,
  dialogContent: `${PREFIX}-dialogContent`,
  alert: `${PREFIX}-alert`,
  textFieldWrap: `${PREFIX}-textFieldWrap`,
};

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${classes.dialogTitleWrap}`]: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "15px",
  },
  [`& .${classes.dialogContent}`]: {
    padding: "0 24px 20px 24px",
  },
  [`& .${classes.alert}`]: {
    margin: "20px 0",
  },
  [`& .${classes.textFieldWrap}`]: {
    padding: "25px 15px",
    border: `1px solid ${theme.palette.border.xdrTrialCard}`,
    borderRadius: "10px",
    marginBottom: "10px",
  },
}));
